import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { Input } from '@/src/shadComponents/ui/input';

export default function TextFieldType({ field }: { field: DocumentField }) {
    const [value, setValue] = useState<string>(field.value || '');
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        setFieldValue(field.name, value);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, setFieldValue]);

    return (
        <>
            <div className="mt-2">
                <Input
                    type="text"
                    name={field.name}
                    id={field.name}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="sm:max-w-md"
                />
            </div>
            {field.helperText ? (
                <p className="mt-3 text-sm leading-6 text-muted-foreground">
                    {field.helperText}
                </p>
            ) : null}
        </>
    );
}
